import "./NotableSeniorZonePP.module.css";
import NewsHero from "@/pages/PPZone/sections/NewsHero";
import Zonapphero from "./sections/Zonapphero";
import NewsHighlights from "./sections/NewsHighlights";
import Leadership from "./sections/Leadership";
import Footer from "@/reusable_sections/Footer";
export default function NotableSeniorZonePPPage() {
  return <div>
      <NewsHero activePath="/zona-pp/tokoh-senior" />
      <Zonapphero />
      <NewsHighlights />
      <Leadership />
      <Footer />
    </div>;
}